import React, { useMemo } from 'react'
import { Container, VerticalLine } from './styles'
import { RowInfoPart } from '../rowInfoPart'
import { useGeneralHealthProcedures } from '~/context'
import { mapperTimelineViewByYearsFrom } from '~/utils/dashboard/timeline/general'

export const CollapsedTimeline = (): JSX.Element => {
  const { displayedHealthProcedures } = useGeneralHealthProcedures()
  const yearsOfDisplayedHealthProcedures = useMemo(() => {
    return mapperTimelineViewByYearsFrom(displayedHealthProcedures)
  }, [displayedHealthProcedures])

  return (
    <Container>
      {yearsOfDisplayedHealthProcedures.years.map((year, yearIndex, yearArray) => (
        <RowInfoPart key={year.id} isFilled={false} period={`${year.id} (${year.yearRowSlotsTotal})`}>
          <VerticalLine isFirst={yearIndex === 0} isLast={yearIndex === yearArray.length - 1} />
        </RowInfoPart>
      ))}
    </Container>
  )
}
